import { ScrollableCurriculumTabStrip } from "@/components/ui/scrollable-curriculum-tab-strip";
import { Tabs, TabsContent, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import { BeltRank } from "../../MembersArea";

const DEFAULT_TAB_SURFACE = "!bg-gray-200 !text-gray-900";

interface PyongWonProps {
  selectedBelt: BeltRank;
  getBeltColor: (belt: BeltRank) => string;
  hasDemo?: (aliases: string[]) => boolean;
  onWatchDemo?: (aliases: string[]) => void;
  presentation?: "legacy" | "curriculum";
  beltTabSurfaceClass?: string;
}

function PyongWonMovesOl() {
  return (
    <ol className="list-none space-y-2">
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">Beginning</span>
        <span className="text-gray-700">Start in the Overlapping Hands ready position</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">1.</span>
        <span className="text-gray-700">Slide the left foot left into Parallel Stance. Slowly perform a Low Knifehand Opening Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">2.</span>
        <span className="text-gray-700">Without stepping, slowly perform Pushing Hands.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">3.</span>
        <span className="text-gray-700">
          Step right with the right foot to turn 90 right into Left Back Stance (i.e., right foot forward). Right Low Knifehand Block.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">4.</span>
        <span className="text-gray-700">Pivot 180 counterclockwise to Right Back Stance (i.e., left foot forward). Left Middle Knifehand Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">5.</span>
        <span className="text-gray-700">Main Sequence - start by going leftward</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">6.</span>
        <span className="text-gray-700">Slide the left foot forward into Left Front Stance. Right Elbow Uppercut.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">7a.</span>
        <span className="text-gray-700">With the left foot fixed execute a Right Front Kick.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">7b.</span>
        <span className="text-gray-700">Set the right foot down and pivot on the right foot 90 counter-clockwise, perform a Left Turning Side Kick.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">7c.</span>
        <span className="text-gray-700">
          Set the Left foot down and pivot on the left foot 90 degrees in a clockwise rotation, place the right foot down into Left Back Stance (i.e.,
          right foot forward). Rightward Double Knifehand Block.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">8.</span>
        <span className="text-gray-700">Without stepping, move your hands in a big circle. Up and over your head to Right Low Knifehand Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">9.</span>
        <span className="text-gray-700">
          Looking right, pivot counterclockwise 90 degrees to Horse Stance. Rightward Augmented High Side Block (Right arm performing a half mountain
          block, the left across your chest, palm down).
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">10a.</span>
        <span className="text-gray-700">Looking right, without stepping, twist the body to the right and lift the right leg.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">10b.</span>
        <span className="text-gray-700">Stomp the right foot back down into Horse Stance again. Right Pulling Backfist Jaw Strike. Kihap.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">10c.</span>
        <span className="text-gray-700">Without stepping, execute Left Pulling Backfist Strike.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">11.</span>
        <span className="text-gray-700">Looking right, move the left foot rightward in front of the right foot into Cross Stance. Double Elbow Side Strike.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">12.</span>
        <span className="text-gray-700">Looking right, move the right foot rightward into Horse Stance. Opening Mountain Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">13a.</span>
        <span className="text-gray-700">Looking right, raise the right leg into Crane Stance. Diamond Block (left arm high).</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">13b.</span>
        <span className="text-gray-700">
          Looking right, without stepping (i.e., still in the Crane Stance), execute a Right Small Hinge Block (Left side of body. Right arm in front).
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">14a.</span>
        <span className="text-gray-700">Looking right, from the Crane Stance extend the right leg into a Right Side Kick.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">14b.</span>
        <span className="text-gray-700">Repeat the Main Sequence - start by going rightward</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">15.</span>
        <span className="text-gray-700">Pivot clockwise and set the right foot down then pivot into Right Front Stance. Left Elbow Uppercut.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">16a.</span>
        <span className="text-gray-700">With the right foot fixed execute a Left Front Kick.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">16b.</span>
        <span className="text-gray-700">Set the left foot down and pivot on the left foot 90 clockwise, perform a Right Turning Side Kick.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">16c.</span>
        <span className="text-gray-700">
          Set the Right foot down and pivot on the right foot 90 degrees in a counter-clockwise rotation, place the left foot down into Right Back Stance
          (i.e., left foot forward). Leftward Double Knifehand Block.
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">17.</span>
        <span className="text-gray-700">Without stepping, move your hands in a big circle. Up and over your head to a Left Low Knifehand Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">18.</span>
        <span className="text-gray-700">
          Looking left, pivot clockwise 90 degrees to Horse Stance. Leftward Augmented High Side Block (Left arm performing a half mountain block, the
          right across your chest, palm down).
        </span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">19a.</span>
        <span className="text-gray-700">Looking left, without stepping, twist the body to the left and lift the left leg.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">19b.</span>
        <span className="text-gray-700">Stomp the left foot back down into Horse Stance again. Left Pulling Backfist Jaw Strike. Kihap.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">19c.</span>
        <span className="text-gray-700">Without stepping, execute Right Pulling Backfist Strike.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">20.</span>
        <span className="text-gray-700">Looking left, move the right foot leftward in front of the left foot into Cross Stance. Double Elbow Side Strike.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">21.</span>
        <span className="text-gray-700">Looking left, move the left foot leftward into Horse Stance. Opening Mountain Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">22a.</span>
        <span className="text-gray-700">Looking left, raise the left leg into Crane Stance. Diamond Block (right arm high).</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">22b.</span>
        <span className="text-gray-700">Looking left, without stepping (i.e., still in the Crane Stance), execute a Left Small Hinge Block.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">23a.</span>
        <span className="text-gray-700">Looking left, from the Crane Stance extend the left leg into a Left Side Kick with Punch.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">23b.</span>
        <span className="text-gray-700">Ending</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">24.</span>
        <span className="text-gray-700">Set the left down into Left Front Stance. Right Elbow Target Strike.</span>
      </li>
      <li className="flex">
        <span className="mr-2 text-taekwondo-red">End:</span>
        <span className="text-gray-700">Step with the left foot to turn right 90, and finish in the Overlapping Hands position.</span>
      </li>
    </ol>
  );
}

export default function PyongWon({
  selectedBelt,
  getBeltColor: _getBeltColor,
  hasDemo,
  onWatchDemo,
  presentation = "legacy",
  beltTabSurfaceClass = DEFAULT_TAB_SURFACE,
}: PyongWonProps) {
  if (!["BLACK/D3", "BLACK/D4", "BLACK/D5"].includes(selectedBelt)) {
    return null;
  }

  const surface = beltTabSurfaceClass;
  const triggerClass = cn(
    "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-black/10 px-3 py-2 text-xs font-medium md:text-sm",
    surface,
    "data-[state=active]:z-10 data-[state=active]:shadow-md data-[state=active]:ring-2 data-[state=active]:ring-gray-900/40 data-[state=active]:ring-offset-2 data-[state=active]:ring-offset-gray-100",
  );

  const demoBtn =
    hasDemo?.(["pyong_won", "pyongwon"]) ? (
      <button
        type="button"
        className="inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
        onClick={() => onWatchDemo?.(["pyong_won", "pyongwon"])}
      >
        Watch Demonstration Video
      </button>
    ) : null;

  if (presentation === "curriculum") {
    return (
      <div className="rounded-lg bg-gray-50 p-4 md:p-5">
        <h2 className="mb-2 text-lg font-semibold text-taekwondo-red md:text-xl">PyongWon</h2>
        {demoBtn && <div className="mb-3">{demoBtn}</div>}
        <Tabs defaultValue="pattern-information" className="w-full space-y-4">
          <ScrollableCurriculumTabStrip ariaLabelPrefix="PyongWon">
            <TabsTrigger value="pattern-information" className={triggerClass}>
              Pattern Information
            </TabsTrigger>
            <TabsTrigger value="details" className={triggerClass}>
              Details
            </TabsTrigger>
            <TabsTrigger value="meaning" className={triggerClass}>
              Meaning
            </TabsTrigger>
            <TabsTrigger value="key-techniques" className={triggerClass}>
              Key Techniques
            </TabsTrigger>
            <TabsTrigger value="pattern" className={triggerClass}>
              Pattern
            </TabsTrigger>
          </ScrollableCurriculumTabStrip>

          <TabsContent value="pattern-information" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Pattern Information</h4>
              <p className="mb-4 text-gray-700">
                PyongWon represents the vast plain, symbolizing the majestic and profound nature of martial arts mastery. This pattern emphasizes the
                connection between earth and practitioner, demonstrating both grounded stability and expansive movement.
              </p>
            </div>
          </TabsContent>
          <TabsContent value="details" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Pattern Details</h4>
              <ul className="list-disc space-y-1 pl-5 text-gray-700">
                <li>Number of Movements: 44</li>
                <li>Pattern Diagram: Plain (一)</li>
                <li>Starting Position: Ready Stance</li>
              </ul>
            </div>
          </TabsContent>
          <TabsContent value="meaning" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Meaning</h4>
              <p className="text-gray-700">
                PyongWon means &quot;Plain&quot; or &quot;Vast Plain,&quot; representing the expansion of martial techniques to their fullest potential, like the
                endless horizon of a great plain. The pattern emphasizes the importance of being both grounded and expansive in technique.
              </p>
            </div>
          </TabsContent>
          <TabsContent value="key-techniques" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Key Techniques</h4>
              <ul className="list-disc space-y-1 pl-5 text-gray-700">
                <li>Ground force techniques</li>
                <li>Expansive movements</li>
                <li>Advanced stance work</li>
                <li>Power projection methods</li>
                <li>Circular and linear combinations</li>
                <li>Space utilization principles</li>
              </ul>
            </div>
          </TabsContent>
          <TabsContent value="pattern" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Movements</h4>
              <PyongWonMovesOl />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    );
  }

  return (
    <div className="mt-2 rounded-lg bg-gray-50 p-4">
      <div className="space-y-4">
        <div>
          {hasDemo?.(["pyong_won", "pyongwon"]) && (
            <button
              type="button"
              className="mb-3 inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
              onClick={() => onWatchDemo?.(["pyong_won", "pyongwon"])}
            >
              Watch Demonstration Video
            </button>
          )}
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Pattern Information</h4>
          <p className="mb-4 text-gray-700">
            PyongWon represents the vast plain, symbolizing the majestic and profound nature of martial arts mastery. This pattern emphasizes the
            connection between earth and practitioner, demonstrating both grounded stability and expansive movement.
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Pattern Details</h4>
          <ul className="list-disc space-y-1 pl-5 text-gray-700">
            <li>Number of Movements: 44</li>
            <li>Pattern Diagram: Plain (一)</li>
            <li>Starting Position: Ready Stance</li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Meaning</h4>
          <p className="text-gray-700">
            PyongWon means &quot;Plain&quot; or &quot;Vast Plain,&quot; representing the expansion of martial techniques to their fullest potential, like the endless
            horizon of a great plain. The pattern emphasizes the importance of being both grounded and expansive in technique.
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Key Techniques</h4>
          <ul className="list-inside list-disc space-y-1 text-gray-700">
            <li>Ground force techniques</li>
            <li>Expansive movements</li>
            <li>Advanced stance work</li>
            <li>Power projection methods</li>
            <li>Circular and linear combinations</li>
            <li>Space utilization principles</li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Training Focus</h4>
          <ul className="list-inside list-disc space-y-1 text-gray-700">
            <li>Spatial awareness</li>
            <li>Ground connection</li>
            <li>Energy expansion</li>
            <li>Movement efficiency</li>
            <li>Technical breadth</li>
            <li>Environmental adaptation</li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Movements</h4>
          <PyongWonMovesOl />
        </div>
      </div>
    </div>
  );
}
